import { DigitalSignModal } from '@euler/app/components/signature/DigitalSignModal';
import { useOrderFlowContext } from '@euler/app/flows/order/OrderFlowContext';
import { MediaUploadTaskEvent } from '@euler/app/flows/task/functions/task-detail/MediaFileUploadController';
import { showAlert } from '@euler/utils';
import { useBehaviorSubject, usePersistFn } from '@euler/utils/hooks';
import { memo, useCallback, useState } from 'react';

export const WiredOrderDigitalSignModal = memo(() => {
  const {
    showDigitalSignModal$,
    fileUploader,
    updateDetail,
    navigation,
    step$,
    orderDetail$,
    storeConfiguration,
  } = useOrderFlowContext();
  const [visible, setVisible] = useBehaviorSubject(showDigitalSignModal$);
  const [uploadEvent, setUploadEvent] = useState<MediaUploadTaskEvent>();
  const [step] = useBehaviorSubject(step$);
  const [hasContents, setHasContents] = useState(false);

  const onDismiss = usePersistFn(() => {
    if (uploadEvent == null) {
      setVisible(false);
    }
  });

  const onChange = useCallback((path: string) => {
    setHasContents(path.length > 0);
  }, []);

  const onConfirm = usePersistFn(async (uri: string) => {
    fileUploader.enqueue({
      type: 'image',
      contentType: 'image/jpeg',
      localFileUri: uri,
      context: {
        type: 'digital-sign',
      },
      listener: e => {
        if (e.type === 'error') {
          void showAlert('上传签名失败，请稍后重试!');
          setUploadEvent(undefined);
        } else {
          if (e.type === 'finished') {
            setUploadEvent(undefined);
            updateDetail(draft => {
              draft.signImageUrl = e.result.url;
              draft.signedAt = new Date();
            });
            showDigitalSignModal$.next(false);
          } else {
            setUploadEvent(e);
          }
        }
      },
    });
  });

  const onHide = usePersistFn(() => {
    if (step === 'order-info' && hasContents) {
      if (
        storeConfiguration.app?.orderFlow?.fields?.customerSign?.required &&
        !orderDetail$.value.signImageUrl
      ) {
        return;
      }
      navigation.navigate('_previewOrder', {});
    }
  });

  const isUploading =
    uploadEvent?.type === 'begin' ||
    uploadEvent?.type === 'queued' ||
    uploadEvent?.type === 'progress';

  return (
    <DigitalSignModal
      visible={visible}
      onHide={onHide}
      loading={isUploading}
      onDismiss={onDismiss}
      onConfirm={onConfirm}
      onChange={onChange}
    />
  );
});
